var map = {
	"./Bags/index.vue": [
		4921,
		353
	],
	"./Beauty/index.vue": [
		5043,
		43
	],
	"./Electronics/index.vue": [
		4931,
		931
	],
	"./Fashion-1/index.vue": [
		4082,
		82
	],
	"./Fashion-2/index.vue": [
		3988,
		988
	],
	"./Fashion-3/index.vue": [
		6501,
		501
	],
	"./Flower/index.vue": [
		8750,
		750
	],
	"./Furniture/index.vue": [
		7625,
		669
	],
	"./Grocery/index.vue": [
		267,
		267
	],
	"./Gym/index.vue": [
		7218,
		218
	],
	"./Jewellery/index.vue": [
		3178,
		178
	],
	"./Kids/index.vue": [
		9162,
		319
	],
	"./Pets/index.vue": [
		3923,
		923
	],
	"./Shoes/index.vue": [
		1782,
		782
	],
	"./Tools/index.vue": [
		112,
		112
	],
	"./Watch/index.vue": [
		5889,
		889
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6593;
module.exports = webpackAsyncContext;